import { DeviceId } from "hassibot/services_v2/common/types";
import { uuidv4 } from "hassibot/util/uuid";

const LOCAL_STORAGE_USER_PREFIX = "USER_STATE";
export const LOCAL_STORAGE_DEVICE_ID_KEY = `${LOCAL_STORAGE_USER_PREFIX}.DEVICE_ID`;

const ensureDeviceId = (): DeviceId => {
  // get deviceID into the localStorage
  const deviceId = localStorage.getItem(LOCAL_STORAGE_DEVICE_ID_KEY);
  // if DEVICE_ID is null generate uuid and put it into local storage
  if (deviceId === null) {
    const newDeviceId = uuidv4(true);
    localStorage.setItem(LOCAL_STORAGE_DEVICE_ID_KEY, newDeviceId);
    return newDeviceId;
  }
  return deviceId as DeviceId;
};

class AppConfig {
  API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
  ASYNC_API_BASE_URL = import.meta.env.VITE_ASYNC_API_BASE_URL;
  API_WS_BASE_URL = import.meta.env.VITE_API_WS_BASE_URL;
  WWW_BASE_URL = import.meta.env.VITE_WWW_BASE_URL;
  CUSTOMER_SERVICE_BASE_URL = import.meta.env.VITE_CUSTOMER_SERVICE_BASE_URL;
  XIMI_BASE_URL = import.meta.env.VITE_XIMI_BASE_URL;
  IS_DEV = import.meta.env.MODE === "development";
  IS_TEST_ENVS = !!import.meta.env.VITE_IS_TEST_ENVS;
  IS_PRODUCTION_OR_TEST_ENV = import.meta.env.MODE === "production";
  BUILD_HASH = import.meta.env.VITE_BUILD_HASH || `dev-${Math.random().toString(36).substring(3)}`;
  SW_BUILD_HASH: string | null = null;
  SCREEB_APP_ID: string | null = null;
  STREAM_CHAT_API_KEY: string = import.meta.env.VITE_STREAM_CHAT_API_KEY;
  IS_XIMI_MIGRATION_WARNING = import.meta.env.VITE_XIMI_MIGRATION_WARNING === "true";
  IS_XIMI_MIGRATION_ONGOING = import.meta.env.VITE_XIMI_MIGRATION_ONGOING === "true";
  IS_MAINTENANCE_MODE = import.meta.env.VITE_MAINTENANCE_MODE === "true";
  DATADOG_APPLICATION_ID = import.meta.env.VITE_DATADOG_APPLICATION_ID;
  DATADOG_CLIENT_TOKEN = import.meta.env.VITE_DATADOG_CLIENT_TOKEN;
  DEBUG_SERVICE_WORKER = import.meta.env.VITE_DEBUG_SERVICE_WORKER === "true";

  private _deviceId: DeviceId | null = null;
  // lazy load device id as it accesses local storage
  // which might not be available during app initialization
  get DEVICE_ID(): DeviceId {
    if (this._deviceId === null) {
      this._deviceId = ensureDeviceId();
    }
    return this._deviceId;
  }
}

const appConfig = new AppConfig();

export default appConfig;
